/**
 * When the chat's post-reading menu (Rate / Share or "Gift to <name>") may show.
 *
 * A LIVE reading unlocks it at the summary step: the seeker reads the cards,
 * opens the summary, then is asked to rate and share.
 *
 * A REOPENED reading (?reading=<id> from the Journal, a reload, a pasted link)
 * was already finished. Its summary is sealed again so it reads like the live
 * one, but its closing card paints in the chat at once. Waiting for the
 * summary step there left the advice card with no call to action under it
 * (2026-10-07, regression from ee33437). It unlocks straight away.
 */
export function postReadingActionsUnlocked({ summarySeen, reopened } = {}) {
  return !!(summarySeen || reopened)
}
